import dayjs from "dayjs";

export class MirageConstants {
    public static get EmptyOptionLabel() {
        return "(Empty)";
    }
    public static get FieldIsRequiredErrorMsg() {
        return "Complete this field";
    }
    public static get CommonRoot() {
        return "common";
    }
    public static get SystemUserName() {
        return "system";
    }
    public static get AdminPanelPermission() {
        return "AdminPanel";
    }
    public static get FoldersDivider() {
        return "\u003e";
    }
    public static get LcSearchesNoResponseText(): "No response text" {
        return "No response text";
    }
    public static get ValidSqlYearRange() {
        return {
            min: 1753,
            max: 9999,
        };
    }
    public static get WorkingHoursRange() {
        return {
            startHour: 7,
            endHour: 19,
        };
    }
    public static get WorkingHoursDayRange() {
        const workingHours = MirageConstants.WorkingHoursRange;
        return {
            start: dayjs().set("hour", workingHours.startHour).set("minute", 0).set("second", 0).set("millisecond", 0),
            end: dayjs().set("hour", workingHours.endHour).set("minute", 0).set("second", 0).set("millisecond", 0),
        };
    }
    public static get DefaultDateFieldHour() {
        return 12;
    }
    public static get MasterLayerUrl() {
        return "https://api.os.uk/maps/raster/v1/zxy/Outdoor_27700/{z}/{x}/{y}.png?key=bf2uPYA6sCW2htgQ2k1cH8NmPE6kdvVC";
    }
    public static get MasterLayerAttribution() {
        return `<a href="https://www.ordnancesurvey.co.uk/governance/crown-copyright" target="_blank">Contains Ordnance Survey data © Crown copyright 
            and database right ${new Date().getFullYear()}</a>`;
    }

    public static get MaxChunkSize() {
        return 3 * 1024 * 1024;
    }

    public static get RelatedRecordSuffix() {
        return "_relatedRecord";
    }

    public static UserDefinedFullControlsList = [
        "int1",
        "int2",
        "int3",
        "int4",
        "int5",
        "int6",
        "int7",
        "int8",
        "int9",
        "int10",
        "int11",
        "int12",
        "date1",
        "date2",
        "date3",
        "date4",
        "date5",
        "date6",
        "date7",
        "date8",
        "date9",
        "date10",
        "date11",
        "date12",
        "text1",
        "text2",
        "text3",
        "text4",
        "text5",
        "text6",
        "text7",
        "text8",
        "text9",
        "text10",
        "text11",
        "text12",
        "flag1",
        "flag2",
        "flag3",
        "flag4",
        "flag5",
        "flag6",
        "flag7",
        "flag8",
        "flag9",
        "flag10",
        "flag11",
        "flag12",
        "dropdown1",
        "dropdown2",
        "dropdown3",
        "dropdown4",
        "dropdown5",
        "dropdown6",
        "dropdown7",
        "dropdown8",
        "dropdown9",
        "dropdown10",
        "dropdown11",
        "dropdown12",
    ] as const;

    public static UserDefinedFieldsNameToType = (fieldName: string): UserDefinedFieldType | null => {
        if (fieldName.includes("int")) {
            return "Numeric";
        }
        if (fieldName.includes("date")) {
            return "Date";
        }
        if (fieldName.includes("text")) {
            return "Text";
        }
        if (fieldName.includes("flag")) {
            return "Checkbox";
        }
        if (fieldName.includes("dropdown")) {
            return "Dropdown";
        }
        return null;
    };
}

export type UserDefinedFieldType = "Numeric" | "Date" | "Checkbox" | "Text" | "Dropdown";
